// Windows environment variable bug. Adds trailing whitespace on some variables.

const COOKIE_NAME = 'lang';
const LEGACY_COOKIE_NAME = 'language';
const DEFAULT_LANG = 'da';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[2]) : null;
};

const getRootCookieDomain = (): string | null => {
  // Only force root cookie on *.c-web.dk. For localhost/IP it must be omitted.
  const host = window.location.hostname || '';
  if (host === 'c-web.dk' || host.endsWith('.c-web.dk')) return '.c-web.dk';
  return null;
};

const setLangCookie = (lang: string) => {
  const domain = getRootCookieDomain();
  const parts = [
    `${COOKIE_NAME}=${encodeURIComponent(lang)}`,
    `max-age=${ONE_YEAR_SECONDS}`,
    'path=/',
    'SameSite=Lax',
  ];
  if (domain) parts.push(`domain=${domain}`);
  document.cookie = parts.join('; ');
};

const deleteLegacyLanguageCookie = () => {
  const domain = getRootCookieDomain();
  const base = [
    `${LEGACY_COOKIE_NAME}=`,
    'expires=Thu, 01 Jan 1970 00:00:00 GMT',
    'path=/',
    'SameSite=Lax',
  ];

  // delete without domain
  document.cookie = base.join('; ');
  // delete with root domain (if applicable)
  if (domain) document.cookie = [...base, `domain=${domain}`].join('; ');
};

const getLanguageFromCookie = (): string | null => {
  // 1) Prefer new cookie
  const lang = getCookie(COOKIE_NAME);
  if (lang) return lang;

  // 2) Migrate legacy cookie if present
  const legacy = getCookie(LEGACY_COOKIE_NAME);
  if (legacy) {
    setLangCookie(legacy);
    deleteLegacyLanguageCookie();
    return legacy;
  }

  return null;
};

export const __DEV__ =
  process.env.REACT_APP_STAGE === 'local' ||
  process.env.REACT_APP_STAGE === 'local ' ||
  process.env.REACT_APP_STAGE === 'development' ||
  process.env.REACT_APP_STAGE === 'development ';
export const CHUNK_SIZE = 1024 * 1024 * 5; // 5mb
export const TREE_MIN_WIDTH = 210;
export const LANGUAGE =
  getLanguageFromCookie() || navigator.language.split('-')[0] || DEFAULT_LANG;
export const MAX_ZIP_SIZE = 1024 * 1024 * 1024 * 4; // 4GB
export const MAX_SINGLE_FILE_SIZE = 1024 * 1024 * 1024 * 1; // 1GB
export const DEFAULT_REACT_QUERY_CACHE_TIME = 1000 * 60 * 5; // 5 min
export const DEFAULT_REACT_QUERY_STALE_TIME = 1000 * 60 * 5; // 5 min
export const QUESTIONS_DEFAULT_PAGE_SIZE = 10;
export const LETTER_DEFAULT_PAGE_SIZE = 5;

export const DETAILED_UPLOAD_LIMIT = 50;
export const BULK_UPLOAD_BATCH_SIZE = 10;
export const BULK_UPLOAD_CONCURRENCY = 5;
